/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Sc_ProjectsInputs */

const en_tut_sc_projects = /** @type {(inputs: Tut_Sc_ProjectsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jump to Projects`)
};

const id_tut_sc_projects = /** @type {(inputs: Tut_Sc_ProjectsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lompat ke Proyek`)
};

/**
* | output |
* | --- |
* | "Jump to Projects" |
*
* @param {Tut_Sc_ProjectsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_sc_projects = /** @type {((inputs?: Tut_Sc_ProjectsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Sc_ProjectsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_sc_projects(inputs)
	return en_tut_sc_projects(inputs)
});